export default theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },

  fieldError: {
    color: theme.palette.danger.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  utteranceItem: {
    justifyContent: "space-between",
    fontSize: "13 px",
    alignItems: "center",
    paddingTop: 0,
    paddingBottom: 0
  },
  formGroup: {
    alignItems: "center"
  },
  utteranceIcons: {
    marginLeft: "-25px",
    marginRight: "20px"
  },
  clusterGroup: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  clusterGroupText: {
    display: "flex",
    width: "80%"
  },
  utteranceItemDiv: {
    fontSize: "13px",
    maxWidth: "80%"
  },
  loadMore: {
    display: "flex",
    flexDirection: "row-reverse",
    marginRight: "30px"
  },
  hide: {
    display: "none"
  },
  loadButtons: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
    marginBottom: "20px"
  },
  utteranceSelectedAnswer: {
    display: "flex",
    alignItems: "center"
  },
  utteranceSelectedAnswerText: {
    marginRight: "15px",
    fontSize: "13px"
  },
  utternaceDate: {
    fontSize: "12px",
    fontWeight: "300"
  },
  customSelect: {
    position: "absolute",
    right: "5.25rem",
    backgroundColor: "#f7f7f7",
    borderRadius: "4px"
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "1rem"
  },
  paginationToolbar: {
    paddingLeft: 0
  },
  arrows: {
    "& button": {
      marginRight: "4rem"
    }
  },
  feedbackIcons: {
    width: 25,
    height: 25
  },
  questionButton: {
    marginLeft: -3,
    marginRight: 13
  },
  aboveTreshold: {
    color: "red",
    fontWeight: 500
  }
});
